module.exports = __webpack_public_path__ + "img/PDF.1e715df6.svg";